import { LinearProgress, styled } from "@mui/material";
import { gray200 } from "../../theme";

export const LinearProgressThick = styled(LinearProgress)(({ theme }) => ({
  minHeight: 14, // shrinked to 0 by flex when overflows to scroll
  height: 14,
  backgroundColor: gray200,
}));
